export const hideHubspotChatBubble = () => {
  if (window) {
    window.HubSpotConversations.widget.remove();
  }
};

export const showHubspotChatBubble = () => {
  if (window) {
    window.HubSpotConversations.widget.load();
  }
};

export const showHubspotChatWindow = () => {
  if (window) {
    window.HubSpotConversations.widget.open();
  }
};
